import React, { useState } from 'react'

import { SuccessModal, FeedBackModal } from 'modulesCommon/FeedbackModal/components'

const FeedbackModal = () => {
  const [feedbackModal, manageFeedBackModal] = useState<[string, string] | []>([])

  return (
    <>
      <SuccessModal onFeedback={manageFeedBackModal} />
      <FeedBackModal
        isOpen={feedbackModal.length === 2}
        onClose={() => manageFeedBackModal([])}
        artistName={feedbackModal[0] as string}
        projectName={feedbackModal[1] as string}
      />
    </>
  )
}

export default FeedbackModal
